module.exports = __webpack_public_path__ + "media/images/contacto/chat-8a6a86345d58d66353d43dc144441dae.svg";